'use client';

import { c as _c } from "react/compiler-runtime";
import { scrollBehavior } from '@/features/hof-dashboard/utils/scroll-behavior';
import { useEffect, type RefObject } from 'react';

/**
 * Brings a form's card into view once its tab has rendered, for the rows of the
 * overview, and moves the focus there so a keyboard or screen reader follows. The card is
 * looked up within this dashboard, since a page could hold two. Then the target is forgotten,
 * so a later render does not jump again.
 */
export const useScrollToForm = (container, target, clearTarget) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] !== clearTarget || $[1] !== container || $[2] !== target) {
    t0 = () => {
      if (target === undefined) {
        return;
      }
      const frame = requestAnimationFrame(() => {
        const card = container.current?.querySelector(`[data-form="${CSS.escape(target)}"]`);
        card?.scrollIntoView({
          behavior: scrollBehavior(),
          block: "start"
        });
        card?.focus({
          preventScroll: true
        });
        clearTarget();
      });
      return () => cancelAnimationFrame(frame);
    };
    t1 = [container, target, clearTarget];
    $[0] = clearTarget;
    $[1] = container;
    $[2] = target;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};